import { render, staticRenderFns } from "./purchase-file-download-list.html?vue&type=template&id=38acf7ba&scoped=true&external"
import script from "./purchase-file-download-list.js?vue&type=script&lang=js&external"
export * from "./purchase-file-download-list.js?vue&type=script&lang=js&external"
import style0 from "./purchase-file-download-list.scss?vue&type=style&index=0&id=38acf7ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acf7ba",
  null
  
)

export default component.exports